
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Editor } from '@monaco-editor/react';

const NewCodebase = () => {
    const navigate = useNavigate();
    
    const [codeContent, setCodeContent] = useState({
        dataPreparation: '',
        modelDefinition: '',
        trainingConfig: '',
        evaluation: '',
        visualization: '',
    });

    // Handle content change
    const handleEditorChange = (section, value) => {
        setCodeContent((prev) => ({
            ...prev,
            [section]: value,
        }));
    };

    // Save function (for now, just console.log the values)
    const handleSave = () => {
        console.log("Codebase Saved:", codeContent);
        alert("Codebase saved locally!");
        navigate("/projects");  // Redirect back to project list
    };

    return (
        <div className="container mx-auto p-6">
            <h2 className="text-2xl font-bold mb-4">New Codebase</h2>

            {/* Editors for Different Sections */}
            {Object.keys(codeContent).map((section) => (
                <div key={section} className="mb-6">
                    <h3 className="text-lg font-semibold mb-2 capitalize">{section.replace(/([A-Z])/g, ' $1')}</h3>
                    <Editor
                        height="200px"
                        defaultLanguage="python"
                        theme="vs-dark"
                        value={codeContent[section]}
                        onChange={(value) => handleEditorChange(section, value)}
                        options={{ readOnly: false }}
                    />
                </div>
            ))}

            {/* Save Button */}
            <button
                className="bg-blue-500 text-white px-4 py-2 rounded-lg mt-4"
                onClick={handleSave}
            >
                Save Codebase
            </button>
        </div>
    );
};

export default NewCodebase;
